{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Viršijote pokalbių limitą. „Hacker“ planas leidžia tik 500 pokalbių.",
      "INBOXES": "Viršijote gautų laiškų aplankų limitą. „Hacker“ planas palaiko tik svetainės tiesioginį pokalbį. Papildomiems aplankams, pvz., el. paštui, WhatsApp ir kt., reikalingas mokamas planas.",
      "AGENTS": "Viršijote agentų limitą. „Hacker“ planas leidžia tik 2 agentus.",
      "NON_ADMIN": "Susisiekite su administratoriumi, kad atnaujintumėte planą ir galėtumėte toliau naudotis visomis funkcijomis."
    },
    "TITLE": "Paskyros nustatymai",
    "SUBMIT": "Atnaujinti nustatymai",
    "BACK": "Atgal",
    "DISMISS": "Atsisakyti",
    "UPDATE": {
      "ERROR": "Nepavyko atnaujinti nustatymų, bandykite dar kartą!",
      "SUCCESS": "Sėkmingai atnaujinti paskyros nustatymai"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Ištrinti savo paskyrą",
      "NOTE": "Ištrynus paskyrą, visi jūsų duomenys bus ištrinti.",
      "BUTTON_TEXT": "Ištrinti savo paskyrą",
      "CONFIRM": {
        "TITLE": "Ištrinti paskyrą",
        "MESSAGE": "Paskyros ištrynimo anuliuoti negalima. Įveskite savo paskyros pavadinimą žemiau, kad patvirtintumėte, jog norite ją negrįžtamai ištrinti.",
        "BUTTON_TEXT": "Ištrinti",
        "DISMISS": "Atšaukti",
        "PLACE_HOLDER": "Įveskite {accountName}, kad patvirtintumėte"
      },
      "SUCCESS": "Paskyra pažymėta ištrynimui",
      "FAILURE": "Nepavyko ištrinti paskyros, bandykite dar kartą!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Ši paskyra suplanuota ištrinti {deletionDate}. Tai užsakė administratorius. Ištrynimą galite atšaukti iki šios datos.",
        "MESSAGE_INACTIVITY": "Ši paskyra suplanuota ištrinti {deletionDate} dėl neaktyvumo. Ištrynimą galite atšaukti iki šios datos.",
        "CLEAR_BUTTON": "Atšaukti suplanuotą ištrynimą"
      }
    },
    "FORM": {
      "ERROR": "Ištaisykite formos klaidas",
      "GENERAL_SECTION": {
        "TITLE": "Pagrindiniai nustatymai",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Paskyros ID",
        "NOTE": "Šis ID reikalingas, jei kuriate API pagrįstą integraciją"
      },
      "NAME": {
        "LABEL": "Paskyros vardas",
        "PLACEHOLDER": "Tavo paskyros vardas",
        "ERROR": "Įveskite galiojantį paskyros vardą"
      },
      "LANGUAGE": {
        "LABEL": "Pasirinkti kalbą",
        "PLACEHOLDER": "Tavo paskyros vardas",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Įeinančio el. pašto domenas",
        "PLACEHOLDER": "Domenas, kuriuo gausite el. laiškus",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Pagalbos el. paštas",
        "PLACEHOLDER": "Jūsų įmonės pagalbos el. paštas",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Dienų skaičius, po kurio bilietas turi būti automatiškai uždarytas, jei nėra jokios veiklos",
        "NOTE": "Neaktyvumo valandų skaičius, po kurio bet koks atidarytas pokalbis bus automatiškai išspręstas.",
        "PLACEHOLDER": "30",
        "ERROR": "Įveskite tinkamą automatinio išsprendimo trukmę (mažiausiai 1 diena ir daugiausia 999 dienos)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Dienų skaičius, po kurio tuščias pokalbis, jei nėra jokios veiklos, turi būti automatiškai išspręstas",
        "PLACEHOLDER": "niekada",
        "ERROR": "Įveskite tinkamą automatinio išsprendimo trukmę (mažiausiai 1 diena ir daugiausia 999 dienos)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Jūsų paskyroje leistas pokalbių tęstinumas su el. laiškais.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Dabar galite gauti el. laiškus pasirinktame domene."
      },
      "PHONE": {
        "TITLE": "PBX nustatymai",
        "NOTE": "Sukonfigūruokite ryšį su savo PBX telefono skambučiams",
        "SIP_HOST": {
          "LABEL": "SIP domenas"
        },
        "DIALING_MODE": {
          "LABEL": "Skambinimo režimas",
          "MODES": {
            "direct": "Tiesioginis - skambutis surenkamas iš karto, kai spustelima telefono nuoroda",
            "indirect": "Netiesioginis - telefono numeris paruošiamas telefono valdiklio įvesties lauke"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Prieiga prie skambučių įrašų",
          "MODES": {
            "admin_only": "Tik administratoriai",
            "admin_and_assigned_agent": "Administratoriai ir priskirtas agentas",
            "inbox_members": "Visi agentai, turintys prieigą prie gautų laiškų aplanko"
          }
        }
      },
      "EMAIL": {
        "TITLE": "El. pašto nustatymai",
        "NOTE": "Keičia el. pašto gautų laiškų aplankų veikimą"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Pokalbio laiko žymos rodymo režimas",
        "MODES": {
          "both": "Sukūrimo ir paskutinio veiksmo laikas",
          "last_activity_only": "Tik paskutinis veiksmas",
          "last_customer_message": "Paskutinis kliento pranešimas"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokuoti prastos reputacijos domenus"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Įtraukti pradinį pranešimą atsakant į el. laišką"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Automatiškai išspręsti naują pokalbį"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Automatiškai perkelti naują el. pašto pokalbį į roboto, apdorojusio kontakto užsakymus, pašto dėžutę"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Išplėstinės etiketės - leisti ilgesnius etikečių pavadinimus su didesne iškylančiąja sąsaja"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - automatiškai priskirti pokalbį agentui, kuris parašė paskutinį atsakymą"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Push pranešimų režimas",
        "MODES": {
          "all_inboxes": "Visi gautų laiškų aplankai - siųsti pranešimus apie visų tipų kanalus",
          "chat_only": "Tik pokalbiai - siųsti pranešimus tik apie ne el. pašto kanalus"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Leisti įjungti / išjungti parašą išsiųstuose pranešimuose"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Rodyti agento pokalbio būseną wallboard skydelyje"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Rodyti pilnus priedų pavadinimus be sutrumpinimo"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Prisijungimas slaptažodžiu",
        "MODES": {
          "allowed_for_all": "Leidžiama visiems vartotojams",
          "allowed_for_agents_only": "Leidžiama tik agentams (administratoriai turi naudoti OAuth)",
          "password_login_disabled": "Išjungta - tik OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Yra nauja versija. Įkelkite iš naujo, kad gautumėte naujausius atnaujinimus.",
    "RELOAD_NOW": "Atnaujinti dabar",
    "LEARN_MORE": "Sužinoti daugiau",
    "PAYMENT_PENDING": "Laukiama jūsų mokėjimo. Atnaujinkite savo mokėjimo informaciją, kad galėtumėte toliau naudoti šią programinę įrangą",
    "LIMITS_UPGRADE": "Jūsų paskyra viršijo naudojimo apribojimus, atnaujinkite savo planą, kad galėtumėte toliau naudoti šią programinę įrangą",
    "OPEN_BILLING": "Atidaryti mokėjimą"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Paspauskite Enter, kad pasirinktumėte",
      "ENTER_TO_REMOVE": "Paspausti Enter, kad pašalintumėte",
      "NO_OPTIONS": "Sąrašas tuščias",
      "NO_RESULT": "Rezultatų nerasta",
      "SELECT_ONE": "Pasirinkti vieną",
      "SELECT": "Pasirinkti"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Perspėjimai",
    "MARK_ALL_DONE": "Pažymėti viską kaip atliktą",
    "DELETE_TITLE": "ištrinta",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Neperskaityti Perspėjimai",
      "ALL_NOTIFICATIONS": "Rodyti visus perspėjimus",
      "LOADING_UNREAD_MESSAGE": "Neperskaityti perspėjimai parsiunčiami...",
      "EMPTY_MESSAGE": "Turite neperskaitytų perspėjimų"
    },
    "LIST": {
      "LOADING_MESSAGE": "Perspėjimai parsiunčiami...",
      "404": "Nėra Perspėjimų",
      "TABLE_HEADER": [
        "Vardas",
        "Telefono numeris",
        "Pokalbiai",
        "Paskutinį kartą susisiekta"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Naujas pokalbis",
      "conversation_assignment": "Pokalbis priskirtas",
      "assigned_conversation_new_message": "Naujas pranešimas",
      "participating_conversation_new_message": "Naujas pranešimas",
      "conversation_mention": "Paminėjimas",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Atsijungęs",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Atnaujinti"
    },
    "CONNECTION_LOST": {
      "TITLE": "Ryšys nutrūko",
      "DESCRIPTION": "Nepavyko pasiekti serverio. Patikrinkite ryšį ir bandykite dar kartą.",
      "RETRY": "Bandyti dar kartą"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Ieškoti ar pereiti į",
    "SECTIONS": {
      "GENERAL": "Pagrindinis",
      "REPORTS": "Ataskaitos",
      "CONVERSATION": "Pokalbis",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Pakeisti Priskirtąjį",
      "CHANGE_PRIORITY": "Pakeisti Prioritetą",
      "CHANGE_TEAM": "Pakeisti Komandą",
      "SNOOZE_CONVERSATION": "Atidėti Pokalbį",
      "EXECUTE_MACRO": "Vykdyti makrokomandą",
      "ADD_LABEL": "Pridėti etiketę pokalbiui",
      "REMOVE_LABEL": "Pašalinti pokalbio etiketę",
      "SETTINGS": "Nustatymai",
      "AI_ASSIST": "AI pagalba",
      "APPEARANCE": "Išvaizda",
      "SNOOZE_NOTIFICATION": "Atidėti pranešimą"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Eikite į Pokalbio informacijos skydelį",
      "GO_TO_CONTACTS_DASHBOARD": "Eikite į Kontaktų informacijos skydelį",
      "GO_TO_REPORTS_OVERVIEW": "Eiti į Ataskaitų apžvalgą",
      "GO_TO_CONVERSATION_REPORTS": "Eiti į Pokalbių Ataskaitas",
      "GO_TO_AGENT_REPORTS": "Eiti į Agento Ataskaitas",
      "GO_TO_LABEL_REPORTS": "Eiti į Etiketės Ataskaitas",
      "GO_TO_INBOX_REPORTS": "Eiti į Gautų Laiškų Aplanko Ataskaitas",
      "GO_TO_TEAM_REPORTS": "Eiti į Komandos Ataskaitas",
      "GO_TO_SETTINGS_AGENTS": "Eiti į Agento Nustatymus",
      "GO_TO_SETTINGS_TEAMS": "Eiti į Komandos Nustatymus",
      "GO_TO_SETTINGS_INBOXES": "Eiti į Gautų Laiškų Aplanko Nustatymus",
      "GO_TO_SETTINGS_LABELS": "Eiti į Etiketės Nustatymus",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Eiti į Atsakymų Ruošinių Nustatymus",
      "GO_TO_SETTINGS_APPLICATIONS": "Eiti į Programos Nustatymus",
      "GO_TO_SETTINGS_ACCOUNT": "Eiti į Paskyros Nustatymus",
      "GO_TO_SETTINGS_PROFILE": "Eiti į Profilio Nustatymus",
      "GO_TO_NOTIFICATIONS": "Eikite į Perspėjimus",
      "ADD_LABELS_TO_CONVERSATION": "Pridėti etiketę pokalbiui",
      "ASSIGN_AN_AGENT": "Priskirti Agentą",
      "AI_ASSIST": "AI pagalba",
      "ASSIGN_PRIORITY": "Nustatyti prioritetą",
      "ASSIGN_A_TEAM": "Priskirti komandą",
      "EXECUTE_A_MACRO": "Vykdyti makrokomandą",
      "MUTE_CONVERSATION": "Tildyti pokalbį",
      "UNMUTE_CONVERSATION": "Įjungti pokalbio garsą",
      "REMOVE_LABEL_FROM_CONVERSATION": "Pašalinti pokalbio etiketę",
      "REOPEN_CONVERSATION": "Atidaryti pokalbį",
      "RESOLVE_CONVERSATION": "Išspręsti pokalbį",
      "SEND_TRANSCRIPT": "Siųsti stenogramą el. laišku",
      "SNOOZE_CONVERSATION": "Atidėti Pokalbį",
      "UNTIL_NEXT_REPLY": "Iki kito atsakymo",
      "UNTIL_NEXT_WEEK": "Iki kitos savaitės",
      "UNTIL_TOMORROW": "Iki rytojaus",
      "UNTIL_NEXT_MONTH": "Iki kito mėnesio",
      "AN_HOUR_FROM_NOW": "Iki valandos nuo dabar",
      "UNTIL_CUSTOM_TIME": "Personalizuotas...",
      "CHANGE_APPEARANCE": "Keisti išvaizdą",
      "LIGHT_MODE": "Šviesus",
      "DARK_MODE": "Tamsus",
      "SYSTEM_MODE": "Sistema",
      "SNOOZE_NOTIFICATION": "Atidėti pranešimą"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Paleidžiama informacijos suvestinės programa..."
  },
  "COMMON": {
    "OR": "Ar",
    "CLICK_HERE": "paspausti čia"
  }
}
